module.exports = "/assets/8d3adf94303046320dc3f547bbeb4c2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/JZ.png
// module id = 1528
// module chunks = 0